import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';

import Heading, { HeadingProps } from '../heading/heading';

export interface CardTitleProps extends HeadingProps {
  /** The children to be rendered with the Card.Title. */
  children?: ReactNode;
}

const StyledCardTitle = styled(Heading)<CardTitleProps>({
  label: 'cardTitle',
});

const CardTitle: FC<CardTitleProps> = props => <StyledCardTitle {...props} />;

export { CardTitle };
export default CardTitle;
